import { Box, DialogTitle, DialogTitleProps, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import { BackIcon, CloseIcon } from "shared/icons"

type DialogCaptionBackButtonProps = {
  onBack: () => void
}
export const DialogCaptionBackButton = ({
  onBack
}: DialogCaptionBackButtonProps) => (
  <Tooltip title="戻る">
    <IconButton onClick={onBack}>
      <BackIcon />
    </IconButton>
  </Tooltip>
)

type DialogCaptionCloseButtonProps = {
  onClose: () => void
}
export const DialogCaptionCloseButton = ({
  onClose
}: DialogCaptionCloseButtonProps) => (
  <Tooltip title="閉じる">
    <IconButton onClick={onClose}>
      <CloseIcon />
    </IconButton>
  </Tooltip>
)

type DialogCaptionProps = {
	title?: string
  onBack?: () => void
	onClose: () => void
} & DialogTitleProps
export const DialogCaption = ({
	title,
  onBack,
	onClose,
	...others
}: DialogCaptionProps) => (
	<DialogTitle {...others}>
		<Stack direction="row" spacing={1} alignItems="center">
      {onBack ? <DialogCaptionBackButton onBack={onBack}/> : <></>}
			{title ? (
				<Typography
					variant="h6"
					textAlign="center"
					color="text.primary"
					flexGrow={1}
					overflow="hidden"
					textOverflow="ellipsis"
					whiteSpace="nowrap"
				>
					{title}
				</Typography>
			) : (
				<Box flexGrow={1}/>
			)}
			<DialogCaptionCloseButton onClose={onClose}/>
		</Stack>
	</DialogTitle>
)
